module.exports = __webpack_public_path__ + "static/media/revista_marzo2008.19e2c0e9.png";